import Api from '../Api';

import { url } from './config';
import { AgentCommissionAccount } from './types';

const api = new Api<AgentCommissionAccount>(url);

export default api;
